import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { McpChatStoreState } from './mcpchat.state';
import { getters } from './mcpchat.getters';
import { mutations } from './mcpchat.mutations';
import { actions } from './mcpchat.actions';

VueXHelper.setStoreModule(Module.MCPCHAT, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new McpChatStoreState(),
  getters,
  mutations,
  actions,
};
